// Sticky header
const header = document.getElementById('header');
if (header) {
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 50);
  });
}

// Scroll reveal
const els = document.querySelectorAll('.section-header, .collection-card, .product-card, .testimon');
if (els.length) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('reveal', 'visible'); observer.unobserve(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach((el, i) => { el.classList.add('reveal'); el.style.transitionDelay = `${(i % 4) * 0.1}s`; observer.observe(el); });
}

// Mobile menu
const menuToggle = document.querySelector('.menu-toggle');
const mobileMenu = document.querySelector('.mobile-menu');
const mobileMenuClose = document.querySelector('.mobile-menu-close');
if (menuToggle && mobileMenu) {
  menuToggle.addEventListener('click', () => mobileMenu.classList.add('active'));
  if (mobileMenuClose) mobileMenuClose.addEventListener('click', () => mobileMenu.classList.remove('active'));
  mobileMenu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => mobileMenu.classList.remove('active')));
}

// Product page: image gallery with thumbnails
const mainImg = document.getElementById('main-product-image');
const thumbs = document.querySelectorAll('.product-gallery-thumb');
if (mainImg && thumbs.length) {
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const img = thumb.querySelector('img');
      mainImg.src = img.getAttribute('data-full') || img.src;
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });
}

// Product page: quantity buttons
const qtyMinus = document.querySelector('.quantity-btn.minus');
const qtyPlus = document.querySelector('.quantity-btn.plus');
const qtyInput = document.querySelector('.quantity-input');
if (qtyMinus && qtyPlus && qtyInput) {
  qtyMinus.addEventListener('click', () => { const v = parseInt(qtyInput.value); if (v > 1) qtyInput.value = v - 1; });
  qtyPlus.addEventListener('click', () => { const v = parseInt(qtyInput.value); qtyInput.value = v + 1; });
}

// Product page: variant selection and OOS marking
const variantSelect = document.getElementById('variant-select');
if (variantSelect) {

  // Helper: update Add to Cart button and OOS notice based on availability
  function updateAddToCartState(available) {
    const addToCartBtn = document.getElementById('add-to-cart-btn');
    const oosNotice = document.getElementById('oos-notice');
    if (!addToCartBtn) return;
    if (available) {
      addToCartBtn.textContent = 'Add to Cart';
      addToCartBtn.disabled = false;
      addToCartBtn.className = 'btn btn-primary add-to-cart-btn';
      addToCartBtn.type = 'submit';
      if (oosNotice) oosNotice.style.display = 'none';
    } else {
      addToCartBtn.textContent = 'Sold Out';
      addToCartBtn.disabled = true;
      addToCartBtn.className = 'btn btn-secondary add-to-cart-btn';
      addToCartBtn.type = 'button';
      if (oosNotice) oosNotice.style.display = 'block';
    }
  }

  // Mark sold-out variant buttons based on the select options
  function markSoldOutVariants() {
    // Build a map: variant option values -> availability
    // by reading from the select element's options
    const options = Array.from(variantSelect.options);
    
    // For each variant option button, check if ANY variant with that value is available
    document.querySelectorAll('.product-variants .variant-options').forEach((group, groupIndex) => {
      const buttons = group.querySelectorAll('.variant-option');
      buttons.forEach(btn => {
        const value = btn.getAttribute('data-value');
        // Check if any available variant has this option value
        let isAvailable = false;
        for (const opt of options) {
          const title = opt.textContent.trim();
          const available = opt.getAttribute('data-available') !== 'false';
          // Match by option position (group index + 1 = option position)
          if (available && title.includes(value)) {
            isAvailable = true;
            break;
          }
        }
        
        if (!isAvailable) {
          btn.classList.add('sold-out');
          btn.disabled = true;
          btn.setAttribute('aria-label', value + ' - Sold Out');
        } else {
          btn.classList.remove('sold-out');
          btn.disabled = false;
        }
      });
    });
    
    // Also update Add to Cart for the initial selected variant
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    if (selectedOption) {
      const available = selectedOption.getAttribute('data-available') !== 'false';
      updateAddToCartState(available);
    }
  }

  // If data-available attributes are on options, use them directly
  // Otherwise, mark all as available (backwards compatible)
  markSoldOutVariants();

  // Handle variant option button clicks
  document.querySelectorAll('.variant-option').forEach(opt => {
    if (opt.classList.contains('sold-out')) return;
    opt.addEventListener('click', () => {
      // Update visual selection
      opt.closest('.variant-options').querySelectorAll('.variant-option').forEach(o => o.classList.remove('selected'));
      opt.classList.add('selected');

      // Build selected options string from all variant groups
      const selectedValues = [];
      document.querySelectorAll('.product-variants .variant-options').forEach(group => {
        const selected = group.querySelector('.variant-option.selected');
        if (selected) selectedValues.push(selected.getAttribute('data-value'));
      });
      const combo = selectedValues.join(' / ');

      // Match to hidden select option
      for (let i = 0; i < variantSelect.options.length; i++) {
        if (variantSelect.options[i].textContent.trim().startsWith(combo)) {
          variantSelect.selectedIndex = i;
          // Update Add to Cart button based on this variant's availability
          const available = variantSelect.options[i].getAttribute('data-available') !== 'false';
          updateAddToCartState(available);
          break;
        }
      }
    });
  });
}
